import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";

import { UsersComponent } from './users.component';
import { UsersRoutes } from "./users-routing.module";
import { SharedModule } from "../../shared/shared.module";
import { PasswordComponent } from '../password/password.component';
import { UserDetailComponent } from './user-detail/user-detail.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(UsersRoutes),
    SharedModule
  ],
  declarations: [UsersComponent, PasswordComponent, UserDetailComponent],
  exports: [UserDetailComponent]
})
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/components/users/users.module.ts